import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import classnames from "classnames";

import story from "../../assets/story.png";

import "./Story.scss";

const Story = () => {
  const { pathname } = useLocation();
  return (
    <section className="Story">
      <div className="Story-container">
        <div className="Story-container-banner">
          <div className="Story-container-banner__content">
            <div className="Story-container-banner__content__text">
              <span>30%</span> of high school graduates face the world without a clear path for their education or careers, leaving their true potential unrealized.
            </div>
            <div className="Story-container-banner__content__line" />
            <div className="Story-container-banner__content__text">
              <span>50%</span> of college dropouts point to career uncertainty and mismatched majors as their top reasons for walking away from their future dreams.
            </div>
          </div>
          <div className="Story-container-banner__img">
            <img src={story} alt="" />
          </div>
        </div>
        <div className="Story-container-links">
          <div>
            <Link
              className={classnames("Story-container-links__item", {
                isActive:
                  pathname.includes("stories") && !pathname.includes("parents"),
              })}
              to={"students"}
            >
              Student's Stories
            </Link>
            <Link
              className={classnames("Story-container-links__item", {
                isActive: pathname.includes("parents"),
              })}
              to={"parents"}
            >
              Parent's Stories
            </Link>
          </div>
        </div>
        <Outlet />
      </div>
    </section>
  );
};

export default Story;
